export const IP_FILTERS = [
  {
    name: 'estado',
    comboId: 'estados_inspeccion',
    multiple: true,
  },
  {
    name: 'tipo_instalacion',
    comboId: 'tipo_instalacion',
    multiple: true,
  },
  {
    name: 'fecha_creacion_inicio',
    filterType: 'date',
    maxDateField: 'fecha_creacion_fin',
  },
  {
    name: 'fecha_creacion_fin',
    filterType: 'date',
    minDateField: 'fecha_creacion_inicio',
  },
  {
    name: 'fecha_inspeccion_inicio',
    filterType: 'date',
    maxDateField: 'fecha_inspeccion_fin',
  },
  {
    name: 'fecha_inspeccion_fin',
    filterType: 'date',
    minDateField: 'fecha_inspeccion_inicio',
  },
  {
    name: 'fecha_estado_inicio',
    filterType: 'date',
    maxDateField: 'fecha_estado_fin',
  },
  {
    name: 'fecha_estado_fin',
    filterType: 'date',
    minDateField: 'fecha_estado_inicio',
  },
  {
    name: 'nombre_empresa',
    filterType: 'basic-input',
  },
  {
    name: 'plantilla_empresa',
    comboId: 'ip_plantillas',
    multiple: true,
    filterType: 'autocomplete',
  },
  {
    name: 'responsable',
    filterType: 'basic-input',
  },
  {
    name: 'sin_importe',
    filterType: 'switch',
  },
  {
    name: 'id_provincia',
    comboId: 'ip_provincias',
    filterType: 'autocomplete',
    multiple: true,
  },
  {
    name: 'id_municipio',
    comboId: 'ip_municipios',
    filterType: 'autocomplete',
    multiple: true,
  },
]
